var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor',_vm._g(_vm._b({attrs:{"init":_vm.init}},'editor',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }